<script>
import {mixin_visitor_setting} from "@/utils/mixin";
import {Apply} from "@/entity/entity";
import {getFileUrl} from "@/utils/fileUploadUtils";

export default {
  name: "RecordShowDetailDrawer",
  mixins: [mixin_visitor_setting],
  props: {
    drawerTitle: String,
    areaMap: Object,
    phoneNumShow: Boolean,
  },
  data() {
    return {
      drawerShow: false,
      employee: {},
      visitor: {},
      drawForm: [],
      hasApply: false,
      applyVisitorList: [],
      noteList: [],
    }
  },

  methods: {

    async showRecordDetail(record) {
      if (record.type === "USUAL"){
        await this.setupVisitorSetting(record.type)
        this._tableShowUsualRecord(record)
      } else {
        await this.setupVisitorSetting(record.apply.type)
        this._tableShowApplyRecord(record)
      }
    },


    _tableShowApplyRecord(record) {
      this.hasApply = true
      this.tableShow(record)
    },

    async tableShow(record) {
      this.applyVisitorList = []
      let apply = new Apply(record.apply)
      this.applyVisitorList = await apply.manageGetShowVisitorList()
      console.log("applyVisitorList", this.applyVisitorList)
      if (record.employee === null) {
        record.employee = {name: "", tel:"", workId:""}
      }
      this.drawData = record
      let employeeTel = record.employee.tel
      let visitorTel = record.visitor.tel
      if (!this.phoneNumShow) {
        employeeTel = record.employee.tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        visitorTel = record.visitor.tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }
      let employeeHead = require('@/assets/default_header.webp')
      if (record.employee.head) {
        employeeHead = getFileUrl(record.employee.head)
      }
      let visitorHead = require('@/assets/default_header.webp')
      if (record.visitor.head) {
        visitorHead = getFileUrl(record.visitor.head)
      }

      this.employee = {
        headUrl: employeeHead,
        name: record.employee.name,
        tel: employeeTel,
        workId: record.employee.workId,
      }
      this.visitor = {
        headUrl: visitorHead,
        name: record.visitor.name,
        tel: visitorTel,
        company: record.visitor.company,
      }

      this.drawerShow = true
      this.noteList = []
      let item = record;
      let enterCardNo = record.enterCardNo
      let enterGuardName = record.enterGuardName
      let leaveGuardName = record.leaveGuardName

      let info = "";
      let timeCome = "";
      let timeLeave = ""
      let enterPhotoUrl = ""
      let superEnterAreaName = ""
      let enterAreaName = ""
      let superLeaveAreaName = ""
      let leaveAreaName = ""
      let enterCarNum = ""
      let comments = ""
      if (item.enterAreaId) {
        let area = this.areaMap[item.enterAreaId]
        if (area) {
          if (area.parentId > 0) {
            let superArea = this.areaMap[area.parentId]
            if (superArea) {
              superEnterAreaName = superArea.name
            }
            enterAreaName = area.name
          } else {
            superEnterAreaName = area.name
          }
        }
      }
      if (item.leaveAreaId) {
        let area = this.areaMap[item.leaveAreaId]
        if (area) {
          if (area.parentId > 0) {
            let superArea = this.areaMap[area.parentId]
            if (superArea) {
              superLeaveAreaName = superArea.name
            }
            leaveAreaName = area.name
          } else {
            superLeaveAreaName = area.name
          }
        }
      }

      if (item.completeState) {
        info = this.$options.filters.tableDateFilter(item.completeState, 'param13')
      }
      if (item.enterDate && item.enterTime) {
        timeCome = `${item.enterDate} ${item.enterTime.substr(0, 5)}`
      }
      if (item.leaveDate && item.leaveTime) {
        timeLeave = `${item.leaveDate} ${item.leaveTime.substr(0, 5)}`
      }
      if (item.enterCarNum) {
        enterCarNum = item.enterCarNum
      }
      if (item.comments) {
        comments = item.comments
      }
      if (item.enterPhoto) {
        enterPhotoUrl = getFileUrl(item.enterPhoto)
      }
      this.noteList.push({info, timeCome, timeLeave, enterPhotoUrl, superEnterAreaName, enterAreaName, superLeaveAreaName, leaveAreaName, enterCardNo, enterGuardName, leaveGuardName, enterCarNum, comments})


      this.drawForm = [
        {"title": "开始时间", "value": `${item.apply.beginDate + " " + item.apply.beginTime.substr(0, 5)}`},
        {"title": "结束时间", "value": `${item.apply.endDate + " " + item.apply.endTime.substr(0, 5)}`},
      ]
      if (item.apply && item.apply.forms) {
        item.apply.forms.forEach(subItem => {
          if (item.type === "beginTime" || item.type === "endTime" || item.type === "accompany") {
            return
          }
          this.drawForm.push(subItem)
        })
      }
    },


    _tableShowUsualRecord(record) {
      this.showDrawerUsual(record)

    },

    showDrawerUsual(record) {
      let localEmployee = {
        name: "",
        tel: "",
        workId: "",
      }
      if (record.employee) {
        localEmployee = record.employee
      }

      this.drawData = record
      let employeeTel = localEmployee.tel
      let visitorTel = record.visitor.tel
      if (!this.phoneNumShow) {
        if (employeeTel) {
          employeeTel = localEmployee.tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        }
        if (visitorTel) {
          visitorTel = record.visitor.tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        }
      }
      let employeeHead = require('@/assets/default_header.webp')
      if (localEmployee.head) {
        employeeHead = getFileUrl(localEmployee.head)
      }
      let visitorHead = require('@/assets/default_header.webp')
      if (record.visitor.head) {
        visitorHead = getFileUrl(record.visitor.head)
      }

      this.employee = {
        headUrl: employeeHead,
        name: localEmployee.name,
        tel: employeeTel,
        workId: localEmployee.workId,
      }
      this.visitor = {
        headUrl: visitorHead,
        name: record.visitor.name,
        tel: visitorTel,
        company: record.visitor.company,
      }
      this.drawerShow = true
      this.noteList = []
      let info = this.$options.filters.tableDateFilter(record.completeState, 'param13');
      let timeCome = ""
      if (record.enterDate && record.enterTime) {
        timeCome = record.enterDate + "  " + record.enterTime.substr(0, 5)
      }
      let timeLeave = ""
      if (record.leaveDate && record.leaveTime) {
        timeLeave = record.leaveDate + "  " + record.leaveTime.substr(0, 5)
      }
      let enterPhotoUrl = getFileUrl(record.enterPhoto)
      let superEnterAreaName = ""
      let enterAreaName = ""
      let superLeaveAreaName = ""
      let leaveAreaName = ""
      let enterCardNo = record.enterCardNo
      let enterGuardName = record.enterGuardName
      let leaveGuardName = record.leaveGuardName
      if (record.enterAreaId) {
        let area = this.areaMap[record.enterAreaId]
        if (area) {
          if (area.parentId > 0) {
            let superArea = this.areaMap[area.parentId]
            if (superArea) {
              superEnterAreaName = superArea.name
            }
            enterAreaName = area.name
          } else {
            superEnterAreaName = area.name
          }
        }
      }
      if (record.leaveAreaId) {
        let area = this.areaMap[record.leaveAreaId]
        if (area) {
          if (area.parentId > 0) {
            let superArea = this.areaMap[area.parentId]
            if (superArea) {
              superLeaveAreaName = superArea.name
            }
            leaveAreaName = area.name
          } else {
            superLeaveAreaName = area.name
          }
        }
      }
      let enterCarNum = ""
      if (record.enterCarNum) {
        enterCarNum = record.enterCarNum
      }
      let comments = ""
      if (record.comments) {
        comments = record.comments
      }

      this.noteList.push({info, timeCome, timeLeave, enterPhotoUrl, superEnterAreaName, enterAreaName, superLeaveAreaName, leaveAreaName, enterGuardName, leaveGuardName, enterCardNo, enterCarNum, comments})

    },


  }, // methods

  filters: {
    tableDateFilter(value, prop) {
      if (prop === "param12") {
        switch (value) {
          case 'PROCESS':
            return "审批中"
          case 'PASS':
            return '已通过'
          case 'REJECT':
            return '已拒绝'
          case 'CANCEL':
            return '已撤销'
          case 'NONE':
            return '审批中'
          default:
            return value
        }
      } else if (prop === "param13") {
        switch (value) {
          case 'NO':
            return "未到访"
          case 'ENTER':
            return '已到访'
          case 'LEAVE':
            return '已离开'
          default:
            return value
        }
      } else {
        return value
      }
    },
    phoneNoFilter(value) {
      return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    },
    icCardNoFilter(value) {
      return value.replace(/(\d{5})\d{10}(\d{3})/, '$1****$2')
    }
  }


}
</script>

<template>
  <div>
    <el-drawer class="drawer-content drawer-box" :visible.sync="drawerShow" :with-header="false" direction="rtl" :size="tableWidth">
      <div class="flex justify-between items-center h-16 p-5">
        <div class="font-bold">{{drawerTitle}}</div>
        <button @click="drawerShow = false" class="el-drawer__close-btn"><i class="el-icon-close"></i></button>
      </div>
      <div class="h-0.5 w-full bg-gray-300"></div>
      <el-row>
        <el-col :span="12">
          <div class="grid-content">
            <h4>员工信息</h4>
            <div class="input-item-box"><span class="input-description">头像：</span>
              <el-image class="image-header" :src="employee.headUrl" fit="cover">
              </el-image>
            </div>
            <div class="input-item-box"><span class="input-description">姓名：</span>
              <el-input size="mini"
                        v-model="employee.name" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">手机：</span>
              <el-input size="mini"
                        v-model="employee.tel" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">工号：</span>
              <el-input size="mini"
                        v-model="employee.workId" :disabled="true" class="input-short"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content">
            <h4>访客信息</h4>
            <div class="input-item-box"><span class="input-description">头像：</span>
              <el-image class="image-header" :src="visitor.headUrl" fit="cover">
              </el-image>
            </div>
            <div class="input-item-box"><span class="input-description">姓名：</span>
              <el-input size="mini"
                        v-model="visitor.name" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">手机：</span>
              <el-input size="mini"
                        v-model="visitor.tel" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">公司：</span>
              <el-input size="mini"
                        v-model="visitor.company" :disabled="true" class="input-short"></el-input>
            </div>
          </div>

        </el-col>
      </el-row>
      <div class="grid-content" v-if="hasApply">
        <h4>表单信息</h4>
        <div v-for="(item, index) in drawForm" :key="index" class="input-item-box"><span class="input-description-long">{{
            item.title
          }}:</span>
          <el-input size="mini" :placeholder="item.value" :disabled="true" class="input-long"></el-input>
        </div>
      </div>
      <div class="grid-content " v-if="hasApply">
        <h4>全部访客</h4>
        <el-table :data="applyVisitorList" border stripe size="mini">
          <el-table-column prop="name" label="访客姓名" width="70"></el-table-column>
          <el-table-column prop="tel" label="访客手机" width="100">
            <template slot-scope="scope">
              <div v-if="phoneNumShow">{{scope.row.tel}}</div>
              <div v-else>{{scope.row.tel | phoneNoFilter}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="showCardNo" label="访客卡号" width="70"></el-table-column>
          <el-table-column prop="ic" label="身份证号"  v-if="visitorShowSetting.showIC"  width="150">
            <template slot-scope="scope">
              <div v-if="phoneNumShow">{{scope.row.ic}}</div>
              <div v-else>{{scope.row.ic | icCardNoFilter}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="nationality" label="访客国籍"  v-if="visitorShowSetting.showNationality" width="120"></el-table-column>
          <el-table-column prop="tag" label="访客护照" v-if="visitorShowSetting.showPassport" width="90"></el-table-column>
          <el-table-column prop="email" label="访客邮箱" v-if="visitorShowSetting.showEmail"></el-table-column>
          <el-table-column prop="company" label="访客公司"></el-table-column>
        </el-table>
      </div>
      <div class="grid-content">
        <h4>记录信息</h4>
        <template v-for="(item, index) in noteList">
          <div class="input-item-box" :key="`item.info` + index + '-0'"><span
              class="input-description-long">到访情况:</span>
            <el-input size="mini"
                      v-model="item.info" :disabled="true" class="input-long"></el-input>
          </div>
          <div class="input-item-box" :key="'item.enterCardNo' + index + '-0'"><span
              class="input-description-long">签到卡号:</span>
            <el-input size="mini"
                      v-model="item.enterCardNo" :disabled="true" class="input-long"></el-input>
          </div>
          <div class="input-item-box" :key="'item.enterGuardName' + index + '-0'"><span
              class="input-description-long">签到保安:</span>
            <el-input size="mini"
                      v-model="item.enterGuardName" :disabled="true" class="input-long"></el-input>
          </div>
          <div class="input-item-box" :key="'item.leaveGuardName' + index + '-0'"><span
              class="input-description-long">签离保安:</span>
            <el-input size="mini"
                      v-model="item.leaveGuardName" :disabled="true" class="input-long"></el-input>
          </div>

          <div class="input-item-box" :key="'superEnterAreaName' + index + '-0'"><span
              class="input-description-long">签到区域:</span>
            <el-input size="mini"
                      v-model="item.superEnterAreaName" :disabled="true" class="input-long"></el-input>
          </div>
          <div class="input-item-box" :key="'enterAreaName' + index + '-0'"><span
              class="input-description-long">签到子区域:</span>
            <el-input size="mini"
                      v-model="item.enterAreaName" :disabled="true" class="input-long"></el-input>
          </div>
          <div class="input-item-box" :key="'superLeaveAreaName' + index + '-0'"><span
              class="input-description-long">签离区域:</span>
            <el-input size="mini"
                      v-model="item.superLeaveAreaName" :disabled="true" class="input-long"></el-input>
          </div>
          <div class="input-item-box" :key="'leaveAreaName' + index + '-0'"><span
              class="input-description-long">签离子区域:</span>
            <el-input size="mini"
                      v-model="item.leaveAreaName" :disabled="true" class="input-long"></el-input>
          </div>
          <div class="input-item-box" :key="`item.info` + index + '-1'"><span
              class="input-description-long">到访时间:</span>
            <el-input size="mini"
                      v-model="item.timeCome" :disabled="true" class="input-long"></el-input>
          </div>
          <div  class="input-item-box" :key="`item.info` + index + '-2'"><span
              class="input-description-long">离开时间:</span>
            <el-input size="mini"
                      v-model="item.timeLeave" :disabled="true" class="input-long"></el-input>
          </div>
          <div  class="input-item-box" :key="`item.info` + index + '-3'"><span
              class="input-description-long">签到车牌:</span>
            <el-input size="mini"
                      v-model="item.enterCarNum" :disabled="true" class="input-long"></el-input>
          </div>
          <div style="margin-bottom: 20px" class="input-item-box" :key="`item.info` + index + '-4'"><span
              class="input-description-long">签到备注:</span>
            <el-input size="mini"
                      v-model="item.comments" :disabled="true" class="input-long"></el-input>
          </div>

          <div style="margin-bottom: 20px" class="input-item-box" :key="`item.info`  +  + index"><span
              class="input-description-long">签到图片:</span>
            <el-image class="image-photo" :src="item.enterPhotoUrl" fit="cover">
              <div slot="error" class="image-photo">
                <span v-if="item.enterPhotoUrl">加载失败</span>
                <span v-else>没有拍照</span>
              </div>
            </el-image>
          </div>
        </template>

      </div>
    </el-drawer>
  </div>
</template>

<style lang="less" scoped>

.drawer-content {

  .drawer-title {
    margin-left: 10px;
    padding-left: 10px;
    padding-top: 10px;
  }

  .input-short {
    width: 150px;
  }

  .input-long {
    width: 380px;
  }

  .grid-content {
    //padding: 20px;

    margin: 8px 8px 8px 20px;
  }

  .input-item-box {
    display: flex;
    flex-direction: row;
    align-items: start;
    padding-bottom: 8px;
    font-size: 14px;
  }

  .input-description {
    display: inline-block;
    width: 80px;
  }

  .input-description-long {
    display: inline-block;
    width: 120px;
    //text-align: right;
    //margin-right: 8px;
  }
}

.image-header {
  width: 80px;
  height: 100px;
}

.image-photo {
  width: 360px;
  height: 270px;
  background-color: #efefef;
  line-height: 270px;
  text-align: center;
}

.el-input {
  width: calc(100% - 50px);
}


/deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 10px;
}
</style>

